import { Injectable } from '@angular/core';
import { IdleDeadline } from 'requestidlecallback';

import { IdleCallbackService } from './idle-callback.service';

declare var requestIdleCallback: typeof import ('requestidlecallback').requestIdleCallback;
declare var cancelIdleCallback: typeof import ('requestidlecallback').cancelIdleCallback;

@Injectable()
export class BrowserIdleCallbackService implements IdleCallbackService<number> {
    public runWhenIdle(callback: (deadline?: IdleDeadline) => void): number {
        return requestIdleCallback(callback);
    }

    public cancelIdleCallback(handle: number): void {
        cancelIdleCallback(handle);
    }
}
